interface ClaimCardKeyboardProps {
  value: string;
  onChange: (value: string) => void;
  mode: 'text' | 'phone';
}

function ClaimCardKeyboard({ value, onChange, mode }: ClaimCardKeyboardProps) {
  const keyPress = (key: string) => onChange(value + key);
  const backSpace = () => onChange(value.length > 0 ? value.substring(0, value.length - 1) : '');
  const clear = () => onChange('');

  if (mode === 'phone') {
    return (
      <div className="pos-keyboard">
        <div className="pos-keyboard__controls">
          <div className="pos-keyboard__controls-row">
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('1')}>
              1
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('2')}>
              2
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('3')}>
              3
            </button>
          </div>
          <div className="pos-keyboard__controls-row">
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('4')}>
              4
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('5')}>
              5
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('6')}>
              6
            </button>
          </div>
          <div className="pos-keyboard__controls-row">
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('7')}>
              7
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('8')}>
              8
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('9')}>
              9
            </button>
          </div>
          <div className="pos-keyboard__controls-row">
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('+')}>
              +
            </button>
            <button className="pos-keyboard__control" type="button" onClick={() => keyPress('0')}>
              0
            </button>
            <button className="pos-keyboard__control pos-keyboard__control_role_backspace" type="button" onClick={backSpace}>
              ←
            </button>
          </div>
          <div className="pos-keyboard__controls-row">
            <button className="pos-keyboard__control pos-keyboard__control_role_space" type="button" onClick={clear}>
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Text mode keyboard
  return (
    <div className="pos-keyboard">
      <div className="pos-keyboard__controls">
        <div className="pos-keyboard__controls-row">
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('Q')}>
            Q
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('W')}>
            W
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('E')}>
            E
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('R')}>
            R
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('T')}>
            T
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('Y')}>
            Y
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('U')}>
            U
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('I')}>
            I
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('O')}>
            O
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('P')}>
            P
          </button>
        </div>
        <div className="pos-keyboard__controls-row">
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('A')}>
            A
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('S')}>
            S
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('D')}>
            D
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('F')}>
            F
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('G')}>
            G
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('H')}>
            H
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('J')}>
            J
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('K')}>
            K
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('L')}>
            L
          </button>
        </div>
        <div className="pos-keyboard__controls-row">
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('Z')}>
            Z
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('X')}>
            X
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('C')}>
            C
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('V')}>
            V
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('B')}>
            B
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('N')}>
            N
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('M')}>
            M
          </button>
          <button className="pos-keyboard__control" type="button" onClick={() => keyPress('-')}>
            -
          </button>
          <button className="pos-keyboard__control pos-keyboard__control_role_backspace" type="button" onClick={backSpace}>
            ←
          </button>
        </div>
        <div className="pos-keyboard__controls-row">
          <button className="pos-keyboard__control pos-keyboard__control_role_space" type="button" onClick={() => keyPress(' ')}>
            Space
          </button>
          <button className="pos-keyboard__control" type="button" onClick={clear}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClaimCardKeyboard;
